<h2 class="text-center" mat-dialog-title>Gestion des co-propriétaires</h2>
<div mat-dialog-content>
  <div class="formContainer">
    <form [formGroup]="ownersForm" (ngSubmit)="onSubmit()">
      <div class="formGroup">
        <p>
          <span class="font-weight-bold mr-3">Nom du bien</span><span>{{ data.prop.name }}</span>
        </p>
        <p>
          <span class="font-weight-bold mr-3">Propriétaire</span><span>{{
            UserHelper.userSummmaryDisplayName(data.prop.owner)}}</span><a *ngIf="data.prop.coOwner"
            class="ml-5 align-bottom"
            (click)="confirmDeleteOwner(data.prop.owner.uid, UserHelper.userSummmaryDisplayName(data.prop.owner))"
            appTooltip="Supprimer le propriétaire">
            <mat-icon color="primary" aria-label="Supprimer le propriétaire">delete_forever</mat-icon>
          </a>
        </p>
        <p *ngIf="data.prop.coOwner">
          <span class="font-weight-bold mr-3">Co-Propriétaire</span><span>{{
            UserHelper.userSummmaryDisplayName(data.prop.coOwner) }}</span><a class="ml-5 align-bottom"
            (click)="confirmDeleteOwner(data.prop.coOwner.uid, UserHelper.userSummmaryDisplayName(data.prop.coOwner))"
            appTooltip="Supprimer le propriétaire">
            <mat-icon color="primary" aria-label="Supprimer le propriétaire">delete_forever</mat-icon>
          </a>
        </p>
      </div>
      <div class="formGroup">
        <mat-form-field class="w-100">
          <mat-label>Email du co-propriétaire</mat-label>
          <input matInput placeholder="" type="text" required formControlName="coOwnerEmail" />
          <mat-hint align="end">Seuls les "Particuliers" sont éligibles</mat-hint>
          <mat-error>
            <span *ngIf="f('coOwnerEmail').hasError('required')">Veuillez saisir l'email du co-propriétaire</span>
          </mat-error>
          <mat-error>
            <span *ngIf="f('coOwnerEmail').hasError('unknown')">Cette adresse ne correspond à aucun utilisateur
              EEMO</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="formValidation" class="text-center">
        <button mat-flat-button class="m-2" color="primary" type="submit"
          [disabled]="formSubmitting || ownersForm.disabled">
          Ajouter
        </button>
        <button mat-flat-button class="m-2" color="primary" mat-dialog-close (click)="onNoClick()">
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
